var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"ma-0 searchbar",attrs:{"label":"Search","prepend-inner-icon":"search","hide-details":"","clearable":""},on:{"input":_vm.filter},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }